// removed by extract-text-webpack-plugin
module.exports = {"Offices":"src-components-Offices----style-module---Offices---2F2Gn","heading":"src-components-Offices----style-module---heading---2X2sJ","locationCard":"src-components-Offices----style-module---locationCard---2s-xI","country":"src-components-Offices----style-module---country---MBhDM","officesIcon":"src-components-Offices----style-module---officesIcon---2ra2v"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Offices/style.module.scss
// module id = 397
// module chunks = 227585929013685